<script setup lang="ts">
import { useClipboard } from "ls/composables/useClipboard";
import { PopoverArrow, PopoverContent, PopoverPortal, PopoverRoot, PopoverTrigger } from "reka-ui";

defineOptions({ inheritAttrs: false });

const props = defineProps<{
  text: string;
  tooltip?: string;
}>();

const { copy, copied } = useClipboard({
  source: () => props.text,
});

async function handleTriggerClick() {
  await copy();
}
</script>

<template>
  <PopoverRoot :open="copied">
    <PopoverTrigger
      v-bind="$attrs"
      as-child
      @click="handleTriggerClick"
    >
      <slot>
        <button type="button" />
      </slot>
    </PopoverTrigger>
    <PopoverPortal>
      <PopoverContent
        side="top"
        align="center"
        :collision-padding="5"
      >
        <div class="rounded-sm bg-slate-800 px-2 py-1 text-white select-none">
          {{ tooltip ?? 'Copied' }}
        </div>
        <PopoverArrow class="fill-slate-800 drop-shadow-md" />
      </PopoverContent>
    </PopoverPortal>
  </PopoverRoot>
</template>
